'use client'

import * as React from 'react'

import { LeftSidebar } from '../left-sidebar'
import { RightSidebar } from '../right-sidebar'
import { ClubhouseSwitcher } from '@web/app/[locale]/clubhouse/[slug]/_components/clubhouse-switcher'
import { SidebarMasterfeedDetails } from '../sidebar-masterfeed-details'
import { tw } from 'utils/classnames'

export function MainContent({
  children,
  activeFeed,
  variant = 'default',
  isTutorialLayout = false,
}: {
  children: React.ReactNode
  activeFeed?: 'projects' | 'saved'
  variant?: 'default' | 'masterfeed-details'
  isTutorialLayout?: boolean
}) {
  return (
    <div id="main-content" className="w-full sm:py-4 sm:!pl-0 !pt-0 lg:pt-6">
      <div className="sm:px-5 sm:pt-6 flex w-full flex-col gap-6 sm:gap-5 pb-10 lg:flex-row lg:pl-0">
        <ClubhouseSwitcher activeFeed={activeFeed} />
        <div className="flex flex-grow px-4 sm:px-0 2xl:mx-auto 2xl:max-w-[1536px]">
          <div className="flex w-full gap-6 justify-center items-stretch">
            {!isTutorialLayout ? <LeftSidebar /> : null}
            <div
              id="main-content-center"
              className={tw(
                'flex justify-center w-full',
                isTutorialLayout ? 'xl:max-w-[1316px]' : 'xl:max-w-[966px] lg:max-w-[756px]',
              )}
            >
              <div
                className={tw(
                  'w-full xl:max-w-[686px]',
                  isTutorialLayout ? 'xl:max-w-[984px]' : '',
                )}
              >
                {children}
              </div>
              {variant === 'default' ? <RightSidebar className="ml-6" /> : null}
              {variant === 'masterfeed-details' ? (
                isTutorialLayout ? (
                  <SidebarMasterfeedDetails className="ml-6 mt-9" />
                ) : (
                  <RightSidebar className="ml-6" />
                )
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
